<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditCareers()"
	(editClicked)="openEdit()"
	[showDeleteButton]="canDeleteCareers()"
	(deleteClicked)="openDeleteDialog()"
	[disableDeleteButton]="isFrozen()"
	[disableDeleteTranslationKey]="'client.career.details.delete_button_disable'"
>
	{{ titleTranslationKey() | transloco: { name: clientName().displayName } }}
</lvr-heading>

<section class="grid" role="region" aria-labelledby="client-relatives-details-heading">
	<!-- Column 1 -->
	<section>
		<table>
			<tr>
				<th>{{ 'client.career.details.start' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ career().startOfCareerStage | date: 'dd.MM.yyyy' }}</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.institution' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ career().workplacesJob?.institutionBranch?.name ?? '-' }}</td>
			</tr>
			<tr>
				<th>{{ cityDistrictTranslationKey() | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ career().cityDistrict?.remark ?? '-' }}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.contact_person' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ career().workplacesJob?.institutionPerson ? `${career().workplacesJob?.institutionPerson?.firstName ??
					''} ${career().workplacesJob?.institutionPerson?.name ?? ''}`: '-' }}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.condition' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ career().participationStatus.remark }}
				</td>
			</tr>
			<tr>
				<th>
					{{ 'client.career.details.type_and_scope_of_workplace' | transloco }}
				</th>
			</tr>
			<tr>
				<td>
					{{ career().workplacesJob?.typeAndScopeOfTheWorkplace ?? '-' }}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.institution_informed' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ getInstitutionInformedTranslationKey() | transloco }}
				</td>
			</tr>
		</table>
	</section>
	<!-- Column 2 -->
	<section>
		<table>
			<tr>
				<th>{{ 'client.career.details.free_text' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ career().remarkOfTheCareerStage }}</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.branch_address' | transloco }}</th>
			</tr>
			<tr>
				<td>
					@if (career().workplacesJob?.institutionBranch) {
						{{ career().workplacesJob?.institutionBranch?.address?.streetAndHouseNumber }} <br />
						{{ career().workplacesJob?.institutionBranch?.address?.postalCodeAndCity }}
					} @else {
						-
					}
				</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.social_security_status' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ career().socialSecurityStatus.remark }}</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.activity' | transloco }}</th>
			</tr>
			<tr>
				<td>{{ career().workplacesJob?.occupationTitle ?? '-' }}</td>
			</tr>
			<tr>
				<th>{{ 'client.career.details.remark' | transloco }}</th>
			</tr>
			<tr>
				<td>
					{{ career().remark ?? '-' }}
				</td>
			</tr>

			@if (isSchoolStatus()) {
				<tr>
					<th>{{ 'client.career.careerOrientationStartYear' | transloco }}</th>
				</tr>
				<tr>
					<td>
						{{ career().careerOrientationStartDate ? (career().careerOrientationStartDate | date: 'yyyy') : '-' }}
					</td>
				</tr>
			}
		</table>
	</section>
</section>
